// src/components/SmartsuppChat.jsx
import { useEffect } from "react";

const SmartsuppChat = () => {
  useEffect(() => {
    // Avoid re-injecting script if it already exists
    if (window.smartsupp) return;

    window._smartsupp = window._smartsupp || {};
    window._smartsupp.key = "4c427812cc917b09b8252df6beb98de266a87bfa";
    // window._smartsupp.offsetX = 100; // move along the X axis by 100 pixels
    window._smartsupp.offsetY = 100; // move along the Y axis by 100 pixels

    (function (d) {
      const s = d.getElementsByTagName("script")[0];
      const c = d.createElement("script");
      c.type = "text/javascript";
      c.charset = "utf-8";
      c.async = true;
      c.src = "https://www.smartsuppchat.com/loader.js?";
      s.parentNode.insertBefore(c, s);
    })(document);
  }, []);

  return null; // It doesn’t render anything visible itself
};

export default SmartsuppChat;
